import React, { useState, useEffect } from 'react';
import { 
  FaFilePdf, FaDownload, FaInfoCircle, 
  FaBullhorn, FaFileAlt, FaLock
} from 'react-icons/fa';
import api from '../../api/axios';
import { toast } from 'react-toastify';

const ManagerProposal = () => {
    const [config, setConfig] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    // URL Download Base (Sesuaikan port backend)
    const BASE_URL = process.env.REACT_APP_BACKEND || '';
    const FILE_DIR = '/uploads/proposal_file/'; // Folder statis di backend

    useEffect(() => {
        const fetchSettings = async () => {
            try {
                const res = await api.get('/settings');
                // Mengambil object config dari response
                const configData = typeof res.data?.config === 'string' 
                    ? JSON.parse(res.data.config) 
                    : res.data?.config || {};
                
                setConfig(configData);
            } catch (error) {
                console.error("Gagal load settings", error);
                toast.error("Gagal memuat data dokumen.");
            } finally {
                setIsLoading(false);
            }
        };
        fetchSettings();
    }, []);

    const handleDownload = (filename) => {
        if (!filename) return toast.warning("File belum diunggah oleh panitia.");

        // Membuka file di tab baru agar browser bisa menangani download/view PDF
        const fileUrl = `${BASE_URL}${FILE_DIR}${filename}`;
        window.open(fileUrl, '_blank');
    };

    if (isLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '70vh' }}>
                <div className="spinner-border text-primary" role="status"></div>
            </div>
        );
    }

    return (
        <div className="container-fluid p-0 animate-fade-in">
            {/* HEADER */}
            <div className="mb-4">
                <h4 className="fw-bold mb-1 text-dark d-flex align-items-center gap-2">
                    <FaFileAlt className="text-primary"/> Dokumen Resmi
                </h4>
                <p className="text-muted small mb-0">Unduh proposal kejuaraan dan baca instruksi panitia dengan saksama.</p>
            </div>

            <div className="row g-4">
                {/* KOLOM KIRI: UNDUH FILE */}
                <div className="col-lg-7">
                    <div className="card border-0 shadow-sm rounded-4 h-100 overflow-hidden">
                        <div className="card-header bg-white border-bottom-0 p-4 pb-0">
                            <h6 className="fw-bold text-dark m-0">Berkas Unduhan</h6>
                        </div>
                        <div className="card-body p-4">
                            {config?.proposal_file ? (
                                /* State: File Tersedia */
                                <div className="bg-light rounded-4 p-4 border border-primary border-opacity-25 position-relative hover-up transition-all">
                                    <div className="d-flex flex-column flex-md-row align-items-center gap-4">
                                        {/* Ikon PDF Besar */}
                                        <div className="bg-white p-4 rounded-4 shadow-sm text-danger d-flex align-items-center justify-content-center flex-shrink-0">
                                            <FaFilePdf size={50} />
                                        </div>
                                        
                                        {/* Detail File */}
                                        <div className="flex-grow-1 text-center text-md-start">
                                            <h5 className="fw-bold text-dark mb-1">Proposal Kejuaraan</h5>
                                            <p className="text-muted small mb-3">Format PDF • Dokumen Resmi Panitia</p>
                                            
                                            <button 
                                                onClick={() => handleDownload(config.proposal_file)}
                                                className="btn btn-primary rounded-pill px-4 py-2 fw-bold shadow-sm d-flex align-items-center gap-2 mx-auto mx-md-0"
                                            >
                                                <FaDownload /> Unduh Dokumen
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                /* State: File Belum Ada */
                                <div className="bg-light rounded-4 p-5 border border-dashed text-center">
                                    <div className="bg-secondary bg-opacity-25 text-secondary rounded-circle d-inline-flex p-4 mb-3">
                                        <FaLock size={30} />
                                    </div>
                                    <h6 className="fw-bold text-dark">Dokumen Belum Tersedia</h6>
                                    <p className="text-muted small mb-0">Panitia belum mengunggah proposal resmi. Silakan cek kembali nanti atau hubungi kontak panitia.</p>
                                </div>
                            )}

                            {/* Info Tambahan */}
                            <div className="mt-4 pt-4 border-top">
                                <h6 className="fw-bold text-dark small mb-3">Penting Sebelum Mendaftar:</h6>
                                <ul className="text-muted small ps-3 mb-0" style={{ lineHeight: '1.8' }}>
                                    <li>Pastikan membaca seluruh regulasi kelas yang dipertandingkan.</li>
                                    <li>Batas usia dihitung berdasarkan tahun kelahiran atlet dikurangi tahun pelaksanaan acara ({config?.event_year || new Date().getFullYear()}).</li>
                                    <li>Ketentuan berat badan Kyorugi merujuk pada aturan terbaru yang tertera di proposal.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                {/* KOLOM KANAN: CATATAN PANITIA */}
                <div className="col-lg-5">
                    <div className="card border-0 shadow-sm rounded-4 bg-primary bg-opacity-25 h-100 position-relative overflow-hidden">
                        <div className="position-absolute end-0 top-0 opacity-25 p-4">
                            <FaBullhorn size={100} />
                        </div>
                        <div className="card-body p-4 position-relative z-1">
                            <div className="d-flex align-items-center gap-2 mb-4 text-primary">
                                <div className="bg-white p-2 rounded text-primary shadow-sm">
                                    <FaInfoCircle size={20} />
                                </div>
                                <h6 className="fw-bold m-0 text-dark">Pengumuman Panitia</h6>
                            </div>
                            
                            <div className="bg-white rounded-4 p-4 shadow-sm border-0">
                                {config?.important_notes && config.important_notes.length > 0 ? (
                                    <ul className="text-dark small ps-3 mb-0 d-flex flex-column gap-3" style={{ lineHeight: '1.6' }}>
                                        {config.important_notes.map((note, idx) => (
                                            <li key={idx} className="fw-medium">{note}</li>
                                        ))}
                                    </ul>
                                ) : (
                                    <div className="text-center py-4">
                                        <p className="small text-muted fst-italic mb-0">Tidak ada pengumuman khusus dari panitia saat ini.</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* CSS STYLE */}
            <style>{`
                .animate-fade-in { animation: fadeIn 0.4s ease-out forwards; }
                .hover-up { transition: transform 0.2s, box-shadow 0.2s; cursor: pointer; }
                .hover-up:hover { transform: translateY(-3px); box-shadow: 0 .5rem 1rem rgba(0,0,0,.08)!important; }
                .border-dashed { border: 2px dashed #dee2e6; }
                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(10px); }
                    to { opacity: 1; transform: translateY(0); }
                }
            `}</style>
        </div>
    );
};

export default ManagerProposal;